module.exports = __webpack_public_path__ + "images/exterior-tour-3d-1-a27c4de278f0ab80aa2d8654e346f4cf.jpg";